import * as AccordionPrimitive from '@radix-ui/react-accordion';
import type { ReactNode } from 'react';
import styles from '@/styles/components/Accordion.module.css';

interface AccordionItemData {
  value: string;
  trigger: ReactNode;
  content: ReactNode;
}

interface AccordionProps {
  items: AccordionItemData[];
  type?: 'single' | 'multiple';
  defaultValue?: string | string[];
  className?: string;
}

export function Accordion({ items, type = 'single', defaultValue, className }: AccordionProps) {
  const rootClasses = [styles.root, className].filter(Boolean).join(' ');

  if (type === 'multiple') {
    return (
      <AccordionPrimitive.Root
        type="multiple"
        defaultValue={defaultValue as string[]}
        className={rootClasses}
      >
        {items.map((item) => (
          <AccordionPrimitive.Item key={item.value} value={item.value} className={styles.item}>
            <AccordionPrimitive.Header>
              <AccordionPrimitive.Trigger className={styles.trigger}>
                {item.trigger}
                <span className={styles.chevron} aria-hidden>
                  ▾
                </span>
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionPrimitive.Content className={styles.content}>
              <div className={styles.contentInner}>{item.content}</div>
            </AccordionPrimitive.Content>
          </AccordionPrimitive.Item>
        ))}
      </AccordionPrimitive.Root>
    );
  }

  return (
    <AccordionPrimitive.Root
      type="single"
      defaultValue={defaultValue as string}
      collapsible
      className={rootClasses}
    >
      {items.map((item) => (
        <AccordionPrimitive.Item key={item.value} value={item.value} className={styles.item}>
          <AccordionPrimitive.Header>
            <AccordionPrimitive.Trigger className={styles.trigger}>
              {item.trigger}
              <span className={styles.chevron} aria-hidden>
                ▾
              </span>
            </AccordionPrimitive.Trigger>
          </AccordionPrimitive.Header>
          <AccordionPrimitive.Content className={styles.content}>
            <div className={styles.contentInner}>{item.content}</div>
          </AccordionPrimitive.Content>
        </AccordionPrimitive.Item>
      ))}
    </AccordionPrimitive.Root>
  );
}
